import { css } from "@microsoft/fast-element";
import { display } from "../../foundation/display";

export const popperStyles = css`
    ${display('none')}

    :host([show]) {
        display: block;
    }
`;
